import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { DateService } from 'src/app/services/date.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { NotificationHandlerService } from 'src/app/services/notification-handler.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent {

  viewNotification: boolean = false;
  notifications: any[] = [];
  staticFileUrl: string = GlobalConstants.staticFilesURL;
  newNotificationCount: number = 0;
  externalCoordinator: any
  isLogin = false

  constructor(
    private router: Router,
    private dataService: DataService,
    private notificationHandler: NotificationHandlerService,
    private dateService: DateService,
    private permissionService: PermissionHandlerService
  ) { }

  hasOpenLibraryPermission() {
    return this.permissionService.payload.kLibrary.allow;
  }

  hasOpenViewPermission() {
    return this.permissionService.payload.dataView.allow;
  }

  ngOnInit() {

    if (localStorage.getItem('isLoggedIn') == 'true') {
      this.isLogin = true
    }

    this.getNotificaitons();
    this.notificationHandler.getNotifications().subscribe(notificaiton => {
      if (!this.isSeen(notificaiton)) {
        this.newNotificationCount += 1;
      }
      this.notifications.unshift(notificaiton);
    });

    let coordinator = localStorage.getItem('externalUser')
    this.externalCoordinator = coordinator ? JSON.parse(coordinator) : false
  }

  checkIsImage(img: string) {
    return this.notificationHandler.checkisImg(img);
  }

  hasPermission(unit: string, flag: string) {
    return this.permissionService.hasPermission(unit, flag);
  }

  handleLogout() {
    localStorage.clear();
    this.router.navigate(['/login']);
  }

  async getNotificaitons() {
    if (this.notifications.length == 0) {
      try {
        let res = await this.dataService.getData('notification');
        if (!res.error) {
          this.notifications = res.data.filter((n: any) => (this.notificationHandler.applyPermissions(n) && this.notificationHandler.applyDatePermission(n)))
            .map((n: any) => {
              if (!this.isSeen(n)) {
                this.newNotificationCount += 1;
              }
              return this.notificationHandler.setNotificationTypeMessage(n);
            });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  getDateDifference(date: any) {
    return this.dateService.getDataDiff(date, new Date())
  }


  isSeen(notification: any): boolean {
    let userId = localStorage.getItem('uid');
    if (!userId) {
      return false;
    }
    return notification.seenBy.includes(userId);
  }

  navigateToFav() {
    let queryParams = { searchTerm: 'fav' };
    this.router.navigate(['/search-view'], { queryParams })
  }

  getFavoriteCount(): string {
    let favorites = JSON.parse(localStorage.getItem('favoriteData') || '[]');
    return favorites.length.toString();
  }
  
  

  async markSeen(notification: any) {
    try {
      if (this.isSeen(notification) == false) {
        let res = await this.dataService.postData('notification/' + notification._id, {}, 'PUT', false);
        if (!res.error) {
          let userId = localStorage.getItem('uid');
          notification.seenBy.push(userId);
          this.newNotificationCount -= 1;
        }
      }
      this.notificationHandler.navigateToRoute(notification);
    } catch (e) {
      console.log(e);
    }
  }
}
